import React from "react";
import "./Process.css";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65 } },
};

const steps = [
  {
    title: "Identify the device",
    description: "Tell us the brand and model — from the label, box, or admin page.",
  },
  {
    title: "Run the right checks",
    description: "Power, network, drivers, pairing, and firmware — sequenced so you don’t skip a critical step.",
  },
  {
    title: "Confirm it works",
    description: "Print a test page or verify Wi‑Fi coverage, then save the setup for next time.",
  },
  {
    title: "Escalate if needed",
    description: "If an error blocks you, connect with a specialist who can see the same flow you’re on.",
  },
];

const Process = () => (
  <section className="prc" aria-label="Our process">
    <div className="prc__page">
      <p className="prc__kicker">How it works</p>
      <h1 className="prc__pageTitle">A simple path to a working device</h1>
      <p className="prc__pageSub">
        No jargon walls. Just the right checks in the right order — then confirmation that you’re connected.
      </p>
    </div>
    <div className="prc__grid">
      {steps.map((s, i) => (
        <motion.article
          key={s.title}
          className="prc__card"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          variants={fadeUp}
          transition={{ delay: i * 0.06 }}
        >
          <span className="prc__step">Step {String(i + 1).padStart(2, "0")}</span>
          <h3 className="prc__h3">{s.title}</h3>
          <p className="prc__p">{s.description}</p>
        </motion.article>
      ))}
    </div>
  </section>
);

export default Process;
